import { type MouseEventHandler } from 'react';
import CloseButton from 'assets/icons/close-x.svg';
import IconButton from 'components/controls/buttons/icon-button';
import styles from './close-button.module.scss';

const ModalCloseButton = ({ handleClick }: IProps) => {
	return (
		<IconButton
			label="Close Modal"
			icon={<CloseButton />}
			autoFocus={true}
			onClick={handleClick}
			className={styles.close}
			data-testid="close-slideshow-button"
		/>
	);
};

export default ModalCloseButton;

interface IProps {
	handleClick: MouseEventHandler;
}
